import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AlertRoutingModule } from './alert-routing.module';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { UIModule } from 'app/ui/ui.module';
import { SharedModule } from 'app/shared/shared.module';
import { AlertListComponent } from './alert-list/alert-list.component';
import { AlertInboxComponent } from './alert-inbox/alert-inbox.component';
import { ModalAlertInboxComponent } from './modal-alert-inbox/modal-alert-inbox.component';
import { AlertEditModalComponent } from './alert-edit-modal/alert-edit-modal.component';
import { EditorModule } from '@tinymce/tinymce-angular';
import { ModalModule } from 'app/modal/modal.module';

@NgModule({
	declarations: [
		AlertListComponent,
		AlertInboxComponent,
		ModalAlertInboxComponent,
		AlertEditModalComponent
	],
	imports: [
		CommonModule,
		RouterModule,
		FormsModule,
		UIModule,
		SharedModule,
		AlertRoutingModule,
		EditorModule,
		ModalModule
	],
	exports: [
		ModalAlertInboxComponent
	]
})
export class AlertModule { }
